// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SihaGetDocumentByExternalIdRequestModel from '../../model/siha-get-document-by-external-id-request-model';
import SihaGetDocumentByExternalIdRequestDTO from '../dto/siha-get-document-by-external-id-request-dto';
import dtoSchema from '../schemas/siha-get-document-by-external-id-request-schema';

export default abstract class SihaGetDocumentByExternalIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SihaGetDocumentByExternalIdRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<SihaGetDocumentByExternalIdRequestDTO>): SihaGetDocumentByExternalIdRequestModel;
  static toModel(dto: DeepPartial<SihaGetDocumentByExternalIdRequestDTO> | undefined | null): SihaGetDocumentByExternalIdRequestModel | undefined;
  static toModel(dto: DeepPartial<SihaGetDocumentByExternalIdRequestDTO> | undefined | null): SihaGetDocumentByExternalIdRequestModel | undefined {
    return dto ? new SihaGetDocumentByExternalIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SihaGetDocumentByExternalIdRequestModel> | SihaGetDocumentByExternalIdRequestModel): SihaGetDocumentByExternalIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as SihaGetDocumentByExternalIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SihaGetDocumentByExternalIdRequestModel, can not map to SihaGetDocumentByExternalIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
